import { render, staticRenderFns } from "./videoCopy.vue?vue&type=template&id=ff5175c4&scoped=true&"
import script from "./videoCopy.vue?vue&type=script&lang=js&"
export * from "./videoCopy.vue?vue&type=script&lang=js&"
import style0 from "./videoCopy.vue?vue&type=style&index=0&id=ff5175c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5175c4",
  null
  
)

export default component.exports